import {runInspectionFn} from "../helper/utils/runInspectionFn";
import {AccessSpecs} from "./AccessSpecs";
import {checkSubscriptionFn} from "./checkSubscriptionFn";
import {checkPermissionFn} from "./checkPermissionFn";
import {checkIntegrationFn} from "./checkIntegrationFn";
import { checkMiscellaneousFn } from "./checkMiscellaneousFn";

export class AccessChecker {
    constructor(specs = new AccessSpecs()) {
        this.specs = specs;
    }

    check({ requiredLevel, inhibitorModifiers } = {}) {
        const {
            access,
        } = this.detailedCheck({ requiredLevel, inhibitorModifiers });
        return access;
    }

    detailedCheck({ requiredLevel, inhibitorModifiers } = {}) {
        const permission = this.checkPermission({ requiredLevel, inhibitorModifiers });
        const subscription = this.checkSubscription();
        const integration = this.checkIntegration();
        const miscellaneousResult = this.checkMiscellaneous(); // { allowedCountryCodes: { allowed: boolean, messageIfBlocked: string, iconIfBlocked: ReactNode }, ...}
        const miscellaneous = Object.values(miscellaneousResult).every(({ allowed }) => allowed);

        return {
            permission,
            subscription,
            integration,
            miscellaneous,
            miscellaneousResult,
            access: permission && subscription && integration && miscellaneous,
        };
    }

    checkPermission({ requiredLevel, inhibitorModifiers } = {}) {
        const permission = runInspectionFn(
            checkPermissionFn,
            this.specs.permission.keys,
            this.specs.permission.checkMethod, // default as 'AND'
            this.specs.permission.getRequiredLevel(requiredLevel),
        );

        const permissionInhibitedByModifiers = this.specs.permission.hasSomeModifier(
            this.specs.permission.getInhibitorModifiers(inhibitorModifiers),
        ); // True == No Permission

        return permission && !permissionInhibitedByModifiers;
    }

    checkSubscription() {
        return runInspectionFn(
            checkSubscriptionFn,
            this.specs.subscription.keys,
            this.specs.subscription.checkMethod, // default as 'AND'
        );
    }

    checkIntegration() {
        return runInspectionFn(
            checkIntegrationFn,
            this.specs.integration.keys,
        );
    }

    checkMiscellaneous() {
        return checkMiscellaneousFn(this.specs.miscellaneous);
    }
}
